module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-regular.d1d5e30a.ttf";